@if (viewers.length) {
  <div class="group relative inline-flex">
    <div class="flex shrink-0 items-center" [ngClass]="stackClass" [attr.title]="showTooltips ? null : viewersTitle" tabindex="0">
      @for (viewer of visibleViewers; track viewer.id) {
        <span
          class="inline-flex rounded-full"
          [ngClass]="avatarWrapperClass"
          [matTooltip]="getViewerTitle(viewer)"
          [matTooltipDisabled]="!showTooltips"
          matTooltipPosition="above"
        >
          <app-avatar
            [url]="getViewerAvatarUrl(viewer)"
            [title]="getViewerTitle(viewer)"
            [size]="avatarSize"
            [isPhotoGallery]="false"
          />
        </span>
      }

      @if (extraViewerCount) {
        <span
          class="inline-flex items-center justify-center rounded-full font-semibold ring-2 ring-white"
          [ngClass]="extraClass"
          [matTooltip]="extraViewersTitle"
          [matTooltipDisabled]="!showTooltips"
          matTooltipClass="[&_.mdc-tooltip__surface]:!whitespace-pre-line [&_.mdc-tooltip__surface]:!text-left"
          matTooltipPosition="above"
          [attr.tabindex]="showTooltips ? 0 : null"
        >
          +{{ extraViewerCount }}
        </span>
      }
    </div>

    @if (showDropdown) {
      <div
        class="pointer-events-none absolute right-0 top-full z-50 mt-2 hidden min-w-44 flex-col gap-1 rounded-lg border border-slate-200 bg-white p-2 text-sm text-slate-700 shadow-lg group-focus-within:flex group-hover:flex"
      >
        @for (viewer of viewers; track viewer.id) {
          <div class="max-w-60 truncate px-2 py-1" [title]="getViewerTitle(viewer)">
            {{ getViewerTitle(viewer) }}
          </div>
        }
      </div>
    }
  </div>
}
